import * as React from "react";
import styled, { css } from "styled-components";

interface Props {
  to: string;
}

const StyledExternalLink = styled.a`
  ${({ theme }) => css`
    display: inline-block;
    color: inherit;
    text-decoration: none;
    border-bottom: 1px solid ${theme.colors.fg};
    transition: all ease-in-out 0.2s;
    &:hover {
      border-bottom: 1px solid ${theme.colors.accent};
      color: ${theme.colors.accent};
    }
  `}
`;

const Link: React.FunctionComponent<Props> = ({ to, children }) => {
  return (
    <StyledExternalLink target="_blank" href={to}>
      {children}
    </StyledExternalLink>
  );
};

export default Link;
